import styles from "./ContextMenu.module.css";
import { createContext, useContext, useEffect, useRef, useState } from "react";

const ContextMenuContext = createContext();

function ContextMenuProvider({ onClose, children }) {
  function closeContextMenu() {
    onClose();
  }
  return <ContextMenuContext.Provider value={{ closeContextMenu }}>{children}</ContextMenuContext.Provider>;
}

export function useContextMenu() {
  return useContext(ContextMenuContext);
}

function ContextMenu({ position, onClose, children, width }) {
  const containerRef = useRef(null);
  const [menuSize, setMenuSize] = useState({ width: 0, height: 0 });
  useEffect(() => {
    if (containerRef.current != null) {
      setMenuSize({
        width: containerRef.current.offsetWidth,
        height: containerRef.current.offsetHeight,
      });
    }
  }, [containerRef]);

  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const posX = position.x + menuSize.width > screenWidth ? screenWidth - menuSize.width - 10 : position.x;
  const posY = position.y + menuSize.height > screenHeight ? screenHeight - menuSize.height - 10 : position.y;

  console.log(`posX:${posX}, posY: ${posY}`);
  const menuWidth = width > 0 ? `${width}px` : "200px";

  return (
    <div
      className={styles.menuOverlay}
      onMouseDown={(e) => {
        onClose();
      }}
    >
      <div
        ref={containerRef}
        className={styles.container}
        style={{
          top: posY,
          left: posX,
          opacity: `${menuSize.width > 0 ? 1 : 0}`,
          width: menuWidth,
        }}
      >
        <ContextMenuProvider
          onClose={() => {
            onClose();
          }}
        >
          {children}
        </ContextMenuProvider>
      </div>
    </div>
  );
}

export default ContextMenu;
